import { DateTime } from 'luxon';

export const CALENDAR_MODAL_TIMEZONE = 'Europe/Paris';

const parseParisDateTime = (value) => {
  if (!value) {
    return null;
  }

  const dateTime = value instanceof Date
    ? DateTime.fromJSDate(value, { zone: CALENDAR_MODAL_TIMEZONE })
    : DateTime.fromISO(String(value), { zone: CALENDAR_MODAL_TIMEZONE });

  return dateTime.isValid ? dateTime.setZone(CALENDAR_MODAL_TIMEZONE) : null;
};
const formatFormValue = (dateTime, isAllDay) => (
  dateTime?.toFormat(isAllDay ? 'yyyy-MM-dd' : "yyyy-MM-dd'T'HH:mm") || ''
);

const getInclusiveAllDayEnd = (start, end) => {
  if (!start || !end || end <= start) {
    return end;
  }

  const endsAtMidnight = end.toMillis() === end.startOf('day').toMillis();
  return endsAtMidnight ? end.minus({ days: 1 }) : end;
};

export const toCalendarModalFormRange = ({ start, end, isAllDay }) => {
  const startDateTime = parseParisDateTime(start);
  const endDateTime = parseParisDateTime(end);

  if (!isAllDay) {
    return {
      start: formatFormValue(startDateTime, false),
      end: formatFormValue(endDateTime, false),
    };
  }

  return {
    start: formatFormValue(startDateTime, true),
    end: formatFormValue(getInclusiveAllDayEnd(startDateTime, endDateTime), true),
  };
};

export const toCalendarModalApiRange = ({ start, end, isAllDay }) => {
  const startDateTime = parseParisDateTime(start);
  const endDateTime = parseParisDateTime(end);

  if (!startDateTime || !endDateTime) {
    return { start: null, end: null };
  }

  if (!isAllDay) {
    return {
      start: startDateTime.toISO(),
      end: endDateTime.toISO(),
    };
  }

  return {
    start: startDateTime.startOf('day').toISO(),
    end: endDateTime.startOf('day').plus({ days: 1 }).toISO(),
  };
};

export const toTimedFormRangeFromAllDay = ({ start, end }) => {
  const apiRange = toCalendarModalApiRange({ start, end, isAllDay: true });
  return toCalendarModalFormRange({
    start: apiRange.start,
    end: apiRange.end,
    isAllDay: false,
  });
};
